import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type updateAttendEventPath =
  operations['AdminGroupEventController_updateGroupEvent']['parameters']['path'];
type updateAttendEventData = components['schemas']['AdminUpdateGroupEventDto'];
type updateAttendEventHeaders =
  operations['AdminGroupEventController_updateGroupEvent']['parameters']['header'];

interface updateAttendEventProps {
  path: updateAttendEventPath;
  data: updateAttendEventData;
  headers?: OmitGroupIdInHeader<updateAttendEventHeaders>;
}

type updateAttendEventResponse = unknown;

export async function updateAttendEvent({
  path,
  data,
  headers,
}: updateAttendEventProps): Promise<updateAttendEventResponse | false> {
  const response = await authenticateRequest<updateAttendEventResponse>({
    method: 'patch',
    url: `/api/v1/admin/group-event/${path.groupEventId}`,
    headers,
    data,
  });

  console.log('updateAttendEvent', { response });
  return response;
}
